import React from 'react';
import { useContactDealer, DOMAIN_CASES } from 'site-modules/shared/components/inventory/contact-dealer/contact-dealer';
import { hasDealerAddressInfo } from 'client/site-modules/shared/utils/inventory-utils/has-dealer-address-info';
import { hasSellerAddressInfo } from 'client/site-modules/shared/utils/inventory-utils/has-seller-address-info';
import { TraditionalDealerOverview } from './overviews/traditional-dealer-overview';
import { DigitalRetailOverview } from './overviews/digital-retail-overview';
import { PrivatePartyOverview } from './overviews/private-party-overview';
import { NonPartnerOverview } from './overviews/non-partner-overview';

export function ContactDealerOverViewFactory() {
  const { domainCase, vinData, isPrivatePartyListing } = useContactDealer();

  if (
    (!hasDealerAddressInfo(vinData) && !isPrivatePartyListing) ||
    (isPrivatePartyListing && !hasSellerAddressInfo(vinData))
  ) {
    return null;
  }

  switch (domainCase) {
    case DOMAIN_CASES.PRIVATE_PARTY:
      return <PrivatePartyOverview />;

    case DOMAIN_CASES.BOL_STANDARD:
    case DOMAIN_CASES.BOL_VLA:
      return <DigitalRetailOverview />;

    case DOMAIN_CASES.TRADITIONAL_NON_PARTNER:
      return <NonPartnerOverview />;

    default:
      return <TraditionalDealerOverview />;
  }
}
